import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-slate-400 py-12 border-t border-navy-800" data-id="element-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl flex flex-col items-center text-center" data-id="element-6">
        <img src="https://cdn.magicpatterns.com/uploads/c5UQRdDneeHuQcb2CfoPds/Level_Up_Insurance_Logo_New_BLK.png" alt="Level Up Insurance" className="h-10 object-contain brightness-0 invert opacity-70 mb-6" data-id="element-7" />
        <p className="text-xs text-slate-500 leading-relaxed mb-6" data-id="element-8">
          La información proporcionada en esta página es solo para fines
          educativos e informativos y no constituye asesoramiento financiero,
          legal o fiscal. Las pólizas de Seguro de Vida Universal Indexado (IUL)
          están sujetas a términos, condiciones y posibles cargos. El potencial
          de acumulación de valor en efectivo depende del rendimiento del índice
          subyacente y no está garantizado. Consulte con un profesional
          financiero calificado antes de tomar decisiones sobre seguros o
          inversiones.
        </p>
        <div className="text-sm" data-id="element-9">
          &copy; {new Date().getFullYear()} Level Up Insurance. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}